module.exports = __webpack_public_path__ + "assets/img/a60dd386e1d20f2d8b61c67f48bfe09b.png";